import React, { useEffect, useState } from "react";
import { Container, Button } from "react-bootstrap";
import Spinner from "react-bootstrap/Spinner";
import useUser from "../../../hooks/useUser";
import {
  getDataCLMFClientVtexByEmail,
  getFindClientAptosByEmail,
  sendEmailConfirmCode,
  getDataClientByEmailInDB,
  newUserByFormAptosVetex
} from "../../../api/apiNewUser";

const SendEmailCodeButton = ({
  isValidEmail,
  confirmEmail,
  setConfirmEmail,
}) => {
  const [showEmailError, setShowEmailError] = useState(false);
  const [sendingMail, setSendingMail] = useState(false);
  const [dataUser, setDataUser] = useUser();

  useEffect(() => {
    if (dataUser.pageReload) {
      setSendingMail(false);
      setShowEmailError(false);
    }

    isValidEmail ? setShowEmailError(false) : setShowEmailError(true);

    return;
  }, [isValidEmail]);

  useEffect(()=>{

  },[dataUser?.dataID?.idAptos,dataUser?.dataID?.idCL,dataUser?.dataID?.idMF])


  const formatGender = (gender)=>{
    let formatedGender='';
    if (gender==='Masculino') formatedGender='male';
    if (gender==='Femenino') formatedGender='female';
    if (formatedGender==='') formatedGender='other';
    return formatedGender
  }

  
  /* const updateDataUserInFrontend = async (data)=>{
    const dataCL= data.dataCL[0];
    const dataMF= data.dataMF[0];
    const {birthDate, cuponvigencia, email}=dataCL
    const { 
      cupon, 
      cupononline, 
      gender, 
      interests, 
      lastname, 
      maritalstatus, 
      name, 
      newsletter, 
      postalcode, 
      privacy, 
      tyc 
    } =dataMF;
    let tempDataUser={
        nameUser: name,
        cuponCode: cupon,
        cuponType: cupononline? 'onLine':'store',
        gender: formatGender(gender),
        maritalStatus: maritalstatus==='soltero'?'single':'married',
        paterno: lastname,
        newsLetter: newsletter==='yes'?true:false,
        zipCode: postalcode,
        privacy: privacy==='yes'?true:false,
        tyc: tyc==='yes'?true:false,
        userPreferences: interests.split(' '),
        userFenac: new Date(birthDate),
        cuponVigencia: cuponvigencia,
        dataID: {idAptos:'', idCL: dataCL.id, idMF: dataMF.id},
        email: email
    }
    console.log('Actualizando DataUser:..',tempDataUser);
    let resUpdateUserinAptos = await newUserByFormAptosVetex(tempDataUser);
    console.log('Backend resUpdateUserinAptos:..',resUpdateUserinAptos);
  } */

  const sendEmailCode = async (e) => {
    e.preventDefault();
    setSendingMail(true);
    //console.log(confirmEmail.email);
    if (!isValidEmail) return; //si el email no es un formato valido no te deja avanzar
    try {
      if (isValidEmail) {
        //De acuerdo al flujo Establecido se enviara primero el codigo de confirmacion de Email
        let backResult = await sendEmailConfirmCode(confirmEmail.email);
        console.log("Result sendEmailConfimCode:", backResult);
        if (backResult?.data?.isInternetAvailable===false){
          setDataUser({
            ...dataUser,
            errorAptos: 'Error en el servicio de Internet:..'
          })
          return
        }
        setConfirmEmail({
          ...confirmEmail,
          code: backResult?.data?.code,
        });
        setSendingMail(false);

        //Buscaremos el Cliente en la DB
        const resGetDataClientByEmailInDB = await getDataClientByEmailInDB(
          confirmEmail.email
        );
        console.log(
          "resGetDataClientByEmailInDB:..",
          resGetDataClientByEmailInDB
        );

        //Aqui comienza la busqueda del email en Aptos y Vtex

        let tempObj = {};
        //Checamos si el correo ya existe en Aptos
        console.log("Checando si el email ya existe en Aptos...");
        let resFindUserinAptos = await getFindClientAptosByEmail(
          confirmEmail.email
        );
        console.log("idAptos:...", resFindUserinAptos?.data);
        if (
          resFindUserinAptos?.data?.duplicityAptos &&
          resFindUserinAptos?.data?.dataResAptos !== ""
        ) {
          //el usuario ya existe en aptos
          tempObj = {
            idAptos: resFindUserinAptos?.data?.dataResAptos,
          };
          //setSendingMail(false);
        }else{
          tempObj = {
            idAptos: null,
          };
        }

        if (resFindUserinAptos?.data?.msg?.includes("Error" || "error")) {
          //Error en aptos
          setDataUser({
            ...dataUser,
            errorAptos: resFindUserinAptos?.data?.msg,
          });
          tempObj = {
            ...tempObj,
            errorAptos: resFindUserinAptos?.data?.msg,
          };
          return
          //setSendingMail(false);
        }

        //Ahora checaremos si el correo ya existe en VTEX
        console.log("Checando si el email ya existe en VTEX...");
        let searchingEmail = await getDataCLMFClientVtexByEmail(
          confirmEmail.email
        );
        console.log("Response VTEX:..", searchingEmail);

        //if(!tempObj.idAptos&&!tempObj.errorAptos&&searchingEmail.data.dataCL[0]) updateDataUserInFrontend(searchingEmail.data);

        if (searchingEmail?.data?.errorVtex) {
          console.log("Error...", searchingEmail?.data?.message);
          setDataUser({
            ...dataUser,
            errorVtex: true,
          });
        }

        if (
          searchingEmail &&
          searchingEmail?.data &&
          searchingEmail?.data?.dataCL[0] !== undefined
        ) {
          console.log('idCLVtex:..',searchingEmail?.data?.dataCL[0].id);
          tempObj = {
            ...tempObj,
            idCL: searchingEmail?.data?.dataCL[0]?.id,
          };
        }else{
          tempObj = {
            ...tempObj,
            idCL: null,
          };
        }

        if (
          searchingEmail &&
          searchingEmail?.data &&
          searchingEmail?.data?.dataMF[0] !== undefined
        ) {
          console.log(searchingEmail?.data?.dataMF[0]?.id);
          tempObj = {
            ...tempObj,
            idMF: searchingEmail?.data?.dataMF[0]?.id,
          };
        }else{
          tempObj = {
            ...tempObj,
            idMF: null,
          };
        }

        setDataUser({
          ...dataUser,
          dataID: {...tempObj},
        });
        return;
      }
    } catch (error) {
      console.log('Error al intentar enviar el Codigo de Acceso:..',error);
      return error;
    }
  };
  return (
    <Container className="sendUserEmail col-sm-12 col-md-8 col-lg-8  d-flex justify-content-center align-items-center flex-column">
      <Button
        className="w-50"
        onClick={sendEmailCode}
        variant="primary"
        type="submit"
        disabled={(!isValidEmail || sendingMail) ? true : false}
      >
        {isValidEmail && sendingMail ? <Spinner /> : "Enviar Código"}
      </Button>

      {((!dataUser.duplicityAptos && dataUser.errorAptos) ||
        dataUser.errorVtex) && (
        <h2 className="text-danger fs-6 mt-3">
          Error en el servicio favor de reintentar mas tarde...
        </h2>
      )}
      {(dataUser.duplicityCL || dataUser.duplicityMF) && (
        <h2 className="text-danger fs-6 mt-3">
          Usuario Actualmente Ya registrado en Vtex
        </h2>
      )}
      {showEmailError && dataUser.email!=='default' && (
        <h2 className="text-danger fs-6 mt-3">
          Ingresar un email válido, gracias.
        </h2>
      )}
    </Container>
  );
};

export default SendEmailCodeButton;
